import React, { useEffect, useState, useRef } from "react";
import { Container } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Signup from "./auth/Signup";
import Signin from "./auth/Signin";
import ForgotPassword from "./auth/ForgotPassword";
import EnterOtp from "./auth/EnterOtp";
import { useSelector } from "react-redux";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const { user } = useSelector((state) => state.auth);

  console.log(user, "user");

  const token = localStorage.getItem("token");

  // Modal visibility states
  const [showSignup, setShowSignup] = useState(false);
  const [showSignin, setShowSignin] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showEnterOtp, setShowEnterOtp] = useState(false);

  // Handlers to open/close modals
  const openSignup = () => {
    closeAllModals();
    setShowSignup(true);
  };
  const closeSignup = () => setShowSignup(false);

  const openSignin = () => {
    closeAllModals();
    setShowSignin(true);
  };
  const closeSignin = () => setShowSignin(false);

  const openForgotPassword = () => {
    closeAllModals();
    setShowForgotPassword(true);
  };
  const closeForgotPassword = () => setShowForgotPassword(false);

  const openResetPassword = () => {
    closeAllModals();
    setShowResetPassword(true);
  };
  const closeResetPassword = () => setShowResetPassword(false);

  const openEnterOtp = () => {
    closeAllModals();
    setShowEnterOtp(true);
  };
  const closeEnterOtp = () => setShowEnterOtp(false);

  // Helper to close all modals before opening one
  const closeAllModals = () => {
    setShowSignup(false);
    setShowSignin(false);
    setShowForgotPassword(false);
    setShowResetPassword(false);
    setShowEnterOtp(false);
  };

  const toggleNavbar = () => {
    setIsActive(!isActive);
  };

  const toggleProfileDropdown = () => {
    navigate('/profile-view')
    // setShowProfileDropdown(!showProfileDropdown);
  };

  const handleLogout = () => {
    localStorage.clear();
    setShowProfileDropdown(false);
    navigate("/");
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setScrolled(scrollTop > 10);
    };

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <section className={`navbar-handle ${isActive ? "active" : ""}`}>
        <Container>
          <div className={`main-navbar ${scrolled ? "scrolled" : ""}`}>
            <div>
              <img
                src={require("../assets/images/logo-main.png")}
                alt=""
                onClick={() => navigate("/")}
              />
              <button onClick={toggleNavbar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="18"
                  viewBox="0 0 22 18"
                  fill="none"
                >
                  <path
                    d="M10.9826 0C7.89579 0 4.80522 0 1.71836 0C0.848564 0 0.241554 0.423825 0.0490894 1.15139C-0.172987 1.98491 0.419216 2.84316 1.31122 2.97384C1.46297 2.99503 1.61473 3.00563 1.77018 3.00563C7.9254 3.00563 14.0843 3.00563 20.2395 3.00563C21.1315 3.00563 21.7348 2.61005 21.9421 1.89662C22.1938 1.03837 21.5979 0.158934 20.6763 0.0317869C20.506 0.00706375 20.3321 0 20.1581 0C17.1008 0 14.0436 0 10.9826 0Z"
                    fill="#1A202C"
                  />
                  <path
                    d="M11.0234 10.5038C14.1028 10.5038 17.1786 10.5038 20.258 10.5038C21.1426 10.5038 21.7422 10.0976 21.9458 9.37713C22.1827 8.53301 21.5942 7.66063 20.6874 7.52996C20.5356 7.50876 20.3839 7.49817 20.2284 7.49817C14.0732 7.49817 7.91429 7.49817 1.75908 7.49817C0.848566 7.49817 0.230452 7.92199 0.041687 8.66369C-0.165585 9.48661 0.422918 10.3378 1.30012 10.4685C1.48148 10.4967 1.66655 10.5003 1.85161 10.5003C4.90886 10.5038 7.96611 10.5038 11.0234 10.5038Z"
                    fill="#1A202C"
                  />
                  <path
                    d="M6.28203 17.9984C7.81436 17.9984 9.34668 18.002 10.8827 17.9984C11.8191 17.9949 12.4743 17.4545 12.5668 16.6245C12.6482 15.8793 12.0819 15.1588 11.3047 15.0281C11.164 15.0034 11.0197 14.9928 10.879 14.9928C7.82176 14.9893 4.76821 14.9893 1.71096 14.9928C0.855967 14.9928 0.256361 15.406 0.0564938 16.123C-0.180389 16.9671 0.411814 17.836 1.31862 17.9666C1.49999 17.9914 1.68505 17.9984 1.87012 17.9984C3.33952 17.9984 4.81263 17.9984 6.28203 17.9984Z"
                    fill="#1A202C"
                  />
                </svg>
              </button>
            </div>
            <div className="nav-links">
              <ul>
                <li>
                  <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link>
                </li>
                <li>
                  <Link to="/medallion" className={location.pathname === '/medallion' ? 'active' : ''}>Medallian</Link>
                </li>
                <li>
                  <Link to="/pet-medallion" className={location.pathname === '/pet-medallion' ? 'active' : ''}>Pet Medallian</Link>
                </li>
                <li>
                  <Link to="/how-it-works" className={location.pathname === '/how-it-works' ? 'active' : ''}>How It Works?</Link>
                </li>
                <li>
                  <Link to="/digital-gift-centre" className={location.pathname === '/digital-gift-centre' ? 'active' : ''}>Digital Gift Centre</Link>
                </li>
                {token ? <li>
                  <Link to="/view-memories" className={(location.pathname === '/view-memories' || location.pathname.includes('profile')) ? 'active' : ''}>View Memories</Link>
                </li> : null}
              </ul>
              {token ? (
                <div
                  className="profile-icon-head"
                  style={{ position: "relative" }}
                  ref={dropdownRef}
                >
                  <button onClick={toggleProfileDropdown}>
                    <img
                      src={user?.profile_image || require("../assets/images/sarahjohnson.png")}
                      alt=""
                    />
                  </button>
                  {showProfileDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        backgroundColor: "white",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        minWidth: "120px",
                        zIndex: 1000,
                      }}
                    >
                      <button
                        onClick={handleLogout}
                        style={{
                          width: "100%",
                          padding: "10px 15px",
                          border: "none",
                          background: "none",
                          textAlign: "left",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <button onClick={openSignup}>App login</button>
              )}
            </div>
          </div>
        </Container>
      </section>
      {/* <section className={`navbar-handle ${isActive ? "active" : ""}`}>
        <Container>
          <div className={`main-navbar ${scrolled ? "scrolled" : ""}`}>
            <div>
              <img
                src={require("../assets/images/logo-main.png")}
                alt=""
                onClick={() => navigate("/")}
              />

              <button onClick={toggleNavbar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="18"
                  viewBox="0 0 22 18"
                  fill="none"
                >
                  <path
                    d="M10.9826 0C7.89579 0 4.80522 0 1.71836 0C0.848564 0 0.241554 0.423825 0.0490894 1.15139C-0.172987 1.98491 0.419216 2.84316 1.31122 2.97384C1.46297 2.99503 1.61473 3.00563 1.77018 3.00563C7.9254 3.00563 14.0843 3.00563 20.2395 3.00563C21.1315 3.00563 21.7348 2.61005 21.9421 1.89662C22.1938 1.03837 21.5979 0.158934 20.6763 0.0317869C20.506 0.00706375 20.3321 0 20.1581 0C17.1008 0 14.0436 0 10.9826 0Z"
                    fill="#1A202C"
                  />
                  <path
                    d="M11.0234 10.5038C14.1028 10.5038 17.1786 10.5038 20.258 10.5038C21.1426 10.5038 21.7422 10.0976 21.9458 9.37713C22.1827 8.53301 21.5942 7.66063 20.6874 7.52996C20.5356 7.50876 20.3839 7.49817 20.2284 7.49817C14.0732 7.49817 7.91429 7.49817 1.75908 7.49817C0.848566 7.49817 0.230452 7.92199 0.041687 8.66369C-0.165585 9.48661 0.422918 10.3378 1.30012 10.4685C1.48148 10.4967 1.66655 10.5003 1.85161 10.5003C4.90886 10.5038 7.96611 10.5038 11.0234 10.5038Z"
                    fill="#1A202C"
                  />
                  <path
                    d="M6.28203 17.9984C7.81436 17.9984 9.34668 18.002 10.8827 17.9984C11.8191 17.9949 12.4743 17.4545 12.5668 16.6245C12.6482 15.8793 12.0819 15.1588 11.3047 15.0281C11.164 15.0034 11.0197 14.9928 10.879 14.9928C7.82176 14.9893 4.76821 14.9893 1.71096 14.9928C0.855967 14.9928 0.256361 15.406 0.0564938 16.123C-0.180389 16.9671 0.411814 17.836 1.31862 17.9666C1.49999 17.9914 1.68505 17.9984 1.87012 17.9984C3.33952 17.9984 4.81263 17.9984 6.28203 17.9984Z"
                    fill="#1A202C"
                  />
                </svg>
              </button>
            </div>

            <div className="nav-links">
              <ul>
                <li>
                  <NavLink to="/" end>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/medallion">Medallian</NavLink>
                </li>
                <li>
                  <NavLink to="/pet-medallion">Pet Medallian</NavLink>
                </li>
                <li>
                  <NavLink to="/how-it-works">How It Works?</NavLink>
                </li>
                <li>
                  <NavLink to="/digital-gift-centre">
                    Digital Gift Centre
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/view-memories">View Memories</NavLink>
                </li>
              </ul>

              {token ? (
                <div
                  className="profile-icon-head"
                  style={{ position: "relative" }}
                  ref={dropdownRef}
                >
                  <button onClick={toggleProfileDropdown}>
                    <img
                      src={require("../assets/images/sarahjohnson.png")}
                      alt=""
                    />
                  </button>
                  {showProfileDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        backgroundColor: "white",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        minWidth: "120px",
                        zIndex: 1000,
                      }}
                    >
                      <button
                        onClick={handleLogout}
                        style={{
                          width: "100%",
                          padding: "10px 15px",
                          border: "none",
                          background: "none",
                          textAlign: "left",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <button onClick={openSignup}>App login</button>
              )}
            </div>
          </div>
        </Container>
      </section> */}

      {/* Signup Modal */}
      <Signup
        show={showSignup}
        onHide={closeSignup}
        openSignin={() => {
          closeSignup();
          openSignin();
        }}
      />

      {/* Signin Modal */}
      <Signin
        show={showSignin}
        onHide={closeSignin}
        openSignup={() => {
          closeSignin();
          openSignup();
        }}
        openForgotPassword={() => {
          closeSignin();
          openForgotPassword();
        }}
      />

      {/* Forgot Password Modal */}
      <ForgotPassword
        show={showForgotPassword}
        onHide={closeForgotPassword}
        openEnterOtp={() => {
          closeForgotPassword();
          openEnterOtp();
        }}
        openSignin={() => {
          closeForgotPassword();
          openSignin();
        }}
        openResetPassword={() => {
          closeForgotPassword();
          openResetPassword();
        }}
      />

      {/* Reset Password Modal */}
      {/* <ResetPassword
        show={showResetPassword}
        onHide={closeResetPassword}
        openEnterOtp={() => {
          closeResetPassword();
          openEnterOtp();
        }}
      /> */}

      {/* Enter OTP Modal */}
      <EnterOtp
        show={showEnterOtp}
        onHide={closeEnterOtp}
        openResetPassword={() => {
          closeEnterOtp();
          openResetPassword();
        }}
      />
    </>
  );
}
